export default __webpack_public_path__ + "da18e32426beeadfaa0a8a07af8953fa.png";